import DataSource from "../DataSource";

export default class CennikService {
  constructor(server){
    this.server = server;
  }

  get(id){
    return this.server("cennik.get", {id: id});
  }

  listSource(){
    return new DataSource(this.server, "cennik.list")
  }

  save(id, item){
    return this.server("cennik.update", {id: id, data: item});
  }

  delete(id){
    return this.server("cennik.delete", {id: id});
  }

  getPolozka(cennikId, polozkaId){
    if (polozkaId)
      return this.server("polozkaCennika.get", {id: polozkaId});
    else
      return {id: 0, cennik: {id: cennikId}};
  }

  savePolozka(id, item){
    return this.server("polozkaCennika.update", {id: id, data: item});
  }

  deletePolozka(id) {
    return this.server("polozkaCennika.delete", {id: id});
  }

  exportXml(id) {
    return this.server("cennik.export.xml", {id: id});
  }

  importXml(base64Data) {
    return this.server("cennik.import.xml", {base64Data: base64Data});
  }

}


// WEBPACK FOOTER //
// ./src/Cennik/CennikService.js